export default __webpack_public_path__ + "002cb1eb71b5eee5ec2f237bed687680.gif";